import { SelfServiceAPI } from 'types';
import isEmpty from 'lodash/isEmpty';
import { sentenceCase } from 'lib/humanize/humanize';

export type PayableAtPropertyBreakdown =
  | Array<{
      description: string;
      charge: SelfServiceAPI.Total;
    }>
  | undefined;

const getExcludePayableAtPropertyLabel = (payableAtPropertyBreakdown: PayableAtPropertyBreakdown) => {
  if (!payableAtPropertyBreakdown || isEmpty(payableAtPropertyBreakdown)) return '';

  return payableAtPropertyBreakdown.reduce((label, { description }, index) => {
    let joinWith = '';

    if (index === 0) {
      joinWith = ' ';
    } else if (index !== payableAtPropertyBreakdown.length - 1) {
      joinWith = ', ';
    } else if (payableAtPropertyBreakdown.length === 2) {
      joinWith = ' and ';
    } else {
      joinWith = ', and ';
    }

    return `${label}${joinWith}${sentenceCase(description).toLowerCase()}`;
  }, 'Excludes');
};

export default getExcludePayableAtPropertyLabel;
